<template>
  <div class="app-order-success">
    <slot name="txtBefore"></slot>
    <div class="order-step">
      <b-overlay class="btn-printpreview-overlay" v-if="showPrintPreviewButton" :show="loadingPrint" spinner-small>
        <b-button @click="print" :disabled="loadingPrint" class="btn-printpreview" type="button" variant="secondary">
          <slot name="btnPrintpreview">drucken</slot>
        </b-button>
      </b-overlay>
      <dyn-slot :slot-data="slotData"><slot name="txtBetween"></slot></dyn-slot>
      <div class="ident-button" v-if="this.getIdentMethod">
        <dyn-slot :slot-data="{ method: this.method, provider: this.provider, successUrl: url }">
          <slot name="txtIdentButton">Success PostIdent {{ url }}</slot>
        </dyn-slot>
      </div>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import { mapMutations, mapGetters } from 'vuex'
import slotProxy from '../../../../../mixins/slotProxy'

export const stepName = 'success'
export default {
  name: 'ShowSuccess',
  components: {
    BButton
  },
  data () {
    return {
      loadingNext: false,
      loadingPrint: false,
      modalShow: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    ...mapGetters('orderProduct/personalData', [
      'identificationCore'
    ]),
    ...mapGetters('orderProduct', [
      'getIdentMethod'
    ]),
    provider () {
      return this.slotData.deferredIdentificationResponse.identProvider
    },
    method () {
      return this.identificationCore.identMethod
    },
    url () {
      return this.slotData.deferredIdentificationResponse.url
    }
  },
  methods: {
    ...mapMutations('orderProduct', [
      'changeStep'
    ]),
    print () {
      this.loadingPrint = true
      /*
       *  Implement printing of order here and set property showPrintPreviewButton
       *  in parent component to true if button doesnt show up
       */
      this.loadingPrint = false
    }
  },
  mixins: [
    slotProxy()
  ],
  props: {
    nextStep: {
      type: String,
      default: 'shoppingCard'
    },
    slotData: Object,
    showPrintPreviewButton: {
      type: Boolean,
      default: true
    }
  }
}
</script>
